<template>
  <div
    id="shareWishlistModal"
    :class="['wish-modal', { show: !loading }]"
    tabindex="-1"
    aria-labelledby="shareWishlistLabel"
    role="dialog"
    aria-modal="true"
    @click="closeModal"
  >
    <section @click="stopPropagation($event)">
      <button
        type="button"
        class="btn fs-7"
        aria-label="Close"
        @click="closeModal"
      >
        <span class="icon-close"></span>
      </button>
      <template v-if="!emailSent">
        <h2 id="shareWishlistLabel">
          Inviter andre til at se listen
          <small>{{ wishlist.name }}</small>
        </h2>
        <div v-if="!showEmailInput">
          <button type="button" class="btn border" @click="copyLinkToClipboard">
            <span v-if="linkCopied">Linket er kopieret</span>
            <span v-else>Kopiér link</span>
          </button>
          <button type="button" class="btn border" @click="renderEmailInputs">
            Del via e-mail
          </button>
        </div>
        <div v-if="showEmailInput">
          <div class="umbraco-forms-field-wrapper">
            <label for="message">Besked i email</label>
            <textarea id="message"></textarea>
          </div>
          <div
            class="umbraco-forms-field-wrapper"
            v-for="(input, index) in addedEmails"
            :key="index"
          >
            <input
              type="email"
              :id="'email' + index"
              value=""
              @blur="(event) => updateEmail(index, event.target.value)"
            />
            <span class="bar"></span>
            <label :for="'email' + index">Email</label>
            <div class="error-info" role="alert" hidden>
              {{ emailErrorText }}
            </div>
            <button
              type="button"
              class="btn text-underline"
              @click="removeEmail(index)"
              v-if="index > 0"
            >
              Fjern
            </button>
          </div>
          <button
            type="button"
            class="btn border"
            @click="addedEmails.push('')"
          >
            Tilføj email
          </button>
          <button type="button" class="btn border" @click="sendEmails">
            {{ sendEmailText }}
          </button>
          <p class="error-info" role="alert" v-if="emailErrorMessage !== null">
            {{ emailErrorMessage }}
          </p>
          <button
            type="button"
            class="btn text-underline"
            @click="showEmailInput = false"
          >
            Fortryd
          </button>
        </div>
      </template>
      <template v-else>
        <h2>{{ emailSuccessMessage }}</h2>
      </template>
    </section>
  </div>
</template>
<script>
import helpers from "../../plugins/globalHelpers.js";
export default {
  name: "ShareWishlistModal",
  props: ["wishlist"],
  data() {
    return {
      loading: true,
      wishlistName: "",
      showEmailInput: false,
      addedEmails: [],
      emailErrorText: "Udfyld venligst med gyldig email",
      linkCopied: false,
      emailErrorMessage: null,
      emailSent: false,
      emailSuccessMessage: "Email er sendt",
    };
  },
  computed: {
    sendEmailText() {
      return this.addedEmails.length > 1 ? "Send emails" : "Send email";
    },
  },
  mounted() {
    this.init();
    helpers.trapFocus(document.getElementById("shareWishlistModal"));
  },
  methods: {
    init: function () {
      document.body.style.paddingRight = "8px";
      document.body.style.overflow = "hidden";
      document.body.classList.add("modal-open");
      setTimeout(() => {
        this.loading = false;
      }, 0);
    },
    closeModal: function () {
      const addToWishlistModal = document.getElementById("favoritesModal");
      if (
        !addToWishlistModal ||
        !addToWishlistModal.classList.contains("show")
      ) {
        document.body.style.removeProperty("overflow");
        document.body.style.removeProperty("padding-right");
        document.body.classList.remove("modal-open");
      }
      this.loading = true;
      setTimeout(() => {
        this.$parent.hideShare();
      }, 300);
    },
    stopPropagation(event) {
      event.stopPropagation();
    },
    copyLinkToClipboard: function () {
      // NB: Only works with https
      navigator.clipboard.writeText(
        window.location.origin +
          this.$store.state.pageUrls.pageProfileFavoriteListPublic +
          "#?publicListId=" +
          this.wishlist.publicId
      );
      this.linkCopied = true;
      setTimeout(() => {
        this.linkCopied = false;
      }, 3000);
    },
    renderEmailInputs: function () {
      this.showEmailInput = true;
      if (!this.addedEmails.length) this.addedEmails.push("");
    },
    removeEmail: function (index) {
      this.addedEmails.splice(index, 1);
    },
    updateEmail: function (index, value) {
      const emailInput = document.getElementById("email" + index);
      this.addedEmails[index] = value;
      emailInput.setAttribute("value", value);
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
        emailInput.classList.remove("error");
        return;
      }
      emailInput.classList.add("error");
    },
    sendEmails: function () {
      let isEmailValid = true;
      for (let [index, email] of this.addedEmails.entries()) {
        if (email === "") {
          document.getElementById("email" + index).classList.add("error");
          isEmailValid = false;
        } else if (
          document.getElementById("email" + index).classList.contains("error")
        ) {
          isEmailValid = false;
        }
      }
      if (isEmailValid) {
        let params = {
          publicListId: this.wishlist.publicId,
          toEmails: this.addedEmails,
          message: document.getElementById("message").value,
        };
        this.$store.dispatch("shareWishlistEmail", params).then((result) => {
          if (result.status) {
            this.emailErrorMessage = result.data.ExceptionMessage;
            this.emailSent = false;
          } else {
            this.emailSuccessMessage = this.addedEmails.length > 1 ? "Emails er sendt" : "Email er sendt";
            this.emailErrorMessage = null;
            this.emailSent = true;
            setTimeout(() => {
              this.closeModal();
            }, 3000);
          }
        });
      }
    },
  },
};
</script>